import { render } from "./mobile-dashboard.vue?vue&type=template&id=2e0c35e6"
import script from "./mobile-dashboard.vue?vue&type=script&lang=js"
export * from "./mobile-dashboard.vue?vue&type=script&lang=js"

import "./mobile-dashboard.vue?vue&type=style&index=0&id=2e0c35e6&lang=css"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__